import React, { useEffect } from 'react'

import Header from '../../components/Header/Header'
import UnderHeader from '../../components/UnderHeader/UnderHeader'
import PageTitle from '../../components/PageTitle/PageTitle'
import Footer from '../../components/Footer/Footer'
import LogoPartner from '../../components/LogoPartner/LogoPartner'
import Subscribe from '../../components/Subscribe/Subscribe'
import Content from '../../components/Content/Content'

export default function Standardgalvanizedwire() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={''} />
      <UnderHeader className={'standardgalvanized'} />
      <PageTitle mainTitle={'STANDARDS GALVANIZED WIRE'} page={'STANDARDS GALVANIZED WIRE'} />
      <Content page={'standardgalvanized'} />
      <Subscribe />
      <LogoPartner />
      <Footer />
    </div>
  )
}
